import SecondaryButton from "@/components/SecondaryButton";
import { REDMPTION_APP_URL } from "@/config";

export default function UsponEarningCard() {
  return (
    <div className="flex flex-col gap-4 items-center">
      <div className="w-full bg-white/5 border-l-4 border-white p-4 flex flex-col md:flex-row gap-6 md:gap-3 items-center">
        <div>
          <span className="text-white">
            If you earned <span className="font-semibold">uSPON</span> during
            the last phase - congratulations! Your{" "}
            <span className="font-semibold">SPON</span> allocation from those
            earnings is now fully unlocked and ready to be claimed. Thank you
            for being an active part of the network.
          </span>
        </div>
        <SecondaryButton
          className="max-w-full md:max-w-[250px]"
          onClick={() => {
            window.open(REDMPTION_APP_URL, "_blank");
          }}
          variant="light"
        >
          Check uSPON Earning
        </SecondaryButton>
      </div>
    </div>
  );
}
